import { Vue, newVue } from '@/config/vue'

let initiated = {}
const defaultSelector = '.js-vue-product-recommendations'

const init = data => {
  const identifier = data.identifier || 'current-page'
  if (initiated[identifier] && !data.forceInit) return

  const selector = data.el || data.selector || defaultSelector
  let props = {}

  if (On.DynamicYield.arrayOfSkusIsValid(data.skus)) {
    props = {
      skus: data.skus,
      generatedByDynamicYield: !!data.generatedByDynamicYield,
    }
  } else if (data.generatedByDynamicYield) {
    On.DynamicYield.trackInvalidRecommendedSkus(data.experimentInfo, data.skus)
  }
  if (data.title) props.title = On.helpers.localize(data.title)

  const ProductRecommendations = Vue.component('product-recommendations', () =>
    import(/* webpackChunkName: "product-recommendations" */ './ProductRecommendations.vue')
  )
  newVue({
    render: h => h(ProductRecommendations, { props }),
    mount: selector,
  })
  initiated[identifier] = true
}

const initDelayedCallback = () => {
  On.DynamicYield.delayedCallback(() => init({ selector: defaultSelector }), 'PDP')
}

On.VueInit({
  controller: 'orders',
  action: 'edit',
  init: initDelayedCallback,
})

On.VueInit({
  controller: 'products',
  action: 'show',
  init: initDelayedCallback,
})

window.On.ProductRecommendationsVueInit = init
